import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { LocationService } from "./location.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs";
import { CoreLogService } from "../../services/log.service";
import { LocationViewModel, NavigationTitleViewModel } from "../../shared/models";
import { ActivatedRoute } from "@angular/router";
import { ContentType, LocationServiceStatus, SnackBarMessageType, SortDirection } from "../../shared/contentTypes";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import Utils from "../../shared/utils";
import { Paging } from "../../shared/paging";
import { PagingHelper } from "../../shared/pagingHelper";
import { SortOption } from "../../shared/models/sort.model";
import { ScrollHelper } from "../../shared/scrollHelper";
import { Router } from "@angular/router";
import { MatInput } from "@angular/material";
import { CoreCOMService } from "../../services/com.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { ReservationSettingService } from "../../services/reservationSetting.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { RouterHelperService } from "../../services/routerHelper.service";
import { CoreLanguageService } from "../../services/language.service";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { Coordinates } from "../../services/com/comEnvironmentGeolocationCoordinates";
import { DeviceLocationService } from "../../services/deviceLocation.service";

@Component({
  selector: "location",
  templateUrl: "./location.component.html",
  styleUrls: ["./location.component.scss"],
  providers: [LocationService, ReservationSettingService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationComponent implements OnInit, OnDestroy {
  /**
   * This function filters the locationList base on the SearchKey in the SearchBox at the top of the page.
   * @param searchKey used for filtering the data. Location name will be filtered by searchKey.
   * @result return a function that is used in paging Class to filter data.
   */
  private static locationLabelFilterFunction(searchKey: string): ((item: LocationViewModel) => boolean) {
    return (location: LocationViewModel): boolean => {
      return (location.label.toLowerCase().includes(searchKey.toLowerCase())
        || location.street.toLowerCase().includes(searchKey.toLowerCase())
        || location.location.toLowerCase().includes(searchKey.toLowerCase())
        || location.zipCode.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  public tabLocationStep = ["phLocation_TabName_Map", "phLocation_TabName_LocationList"];
  public activeLink: string;
  public matGroupSelectedIndex: number;
  public hasData: boolean = true; // check if there is data for this page;
  public initializeMap: boolean = false; // show map for the first time. for next time the map does not initialized
  public locationList: LocationViewModel[];
  public mapLocationList: any[];
  public pageTitle: NavigationTitleViewModel = new NavigationTitleViewModel(); // Used as a title at the header of the page
  public paging: Paging<LocationViewModel>;
  public isSearchEnabled: boolean; // For show and hide searchBox at the top of the page
  public currentLocationMode: boolean = false; // For chack if user select current location icon
  public searchLocationKey: string;
  public contentType = ContentType;
  // public locationTabIndex: number = 0;
  private pagingHelper: PagingHelper;
  private sortOption: SortOption[];
  private filterFunction: ((item: LocationViewModel) => boolean)[];
  private fitBounds: boolean = true;

  private _viewTypeSubscription: Subscription;
  public isSmallView: boolean = false;

  private langSubscriber: Subscription;
  private infiniteScrollSubscriber: Subscription;
  private locationChangesSubscriber: Subscription;
  @ViewChild("locationListView") locationListView: ElementRef;
  @ViewChild("locationSearcInput", { read: MatInput }) searchInput: MatInput;
  // @ViewChild("MatTabGroup") matTabGroup: MatTabGroup;

  constructor(private locationService: LocationService
    , private internationalisationService: InternationalisationService
    , private _coreLanguageService: CoreLanguageService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _activatedRoute: ActivatedRoute
    , private _snackBarService: SnackBarService
    , private _router: Router
    , private _routerHelperService: RouterHelperService
    , private _coreComService: CoreCOMService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _scrollHelper: ScrollHelper
    , private _mainnavService: MainnavService
    , private _iosHelperService: IOSHelperService
    , private _deviceLocationService: DeviceLocationService) {

  }

  ngOnInit() {
    const me = this;
    me.locationList = [];
    me.mapLocationList = [];
    me.pagingHelper = new PagingHelper();
    me.sortOption = [];
    me.isSearchEnabled = false; // to control searchbox show and hide.
    me.searchLocationKey = ""; // binding searchkey to searchbox.
    me.filterFunction = [];
    me.matGroupSelectedIndex = 1;
    me.activeLink = me.tabLocationStep[1];

    me.setRouteData();

    me.langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
      setTimeout(() => {
        me.setLocationsStyle();
      }, 200);
    });

    me.locationChangesSubscriber = me.locationService.ObserveChanges.subscribe((change) => {
      me.ReloadDataAndRender();
    });

    me.initializeSortAndFilterOption();
    me.setInifiniteScrollSunscriber();

    me.onViewTypeChanges(me._mainnavService.viewType);
    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.onViewTypeChanges(viewType);
      me.PushChanges();
    });
    me.ReloadDataAndRender();
  }

  private onViewTypeChanges(viewType: ViewType) {
    const me = this;
    me.isSmallView = (viewType === ViewType.Small);
  }
  /**
 * Set the title of the page by title Data in route data
 * This data has been set in RouterHelperService by each navigation Enh Evnt
 */
  private setRouteData() {
    const me = this;
    me.pageTitle = me._activatedRoute.snapshot.data["pageTitle"];
  }

  // initialize the sorting for first time loading.
  private initializeSortAndFilterOption() {
    const me = this;
    me.sortOption.push(me.pagingHelper.createSortOption("like", SortDirection.DESC));
    me.sortOption.push(me.pagingHelper.createSortOption("distance", SortDirection.ASC));
    me.sortOption.push(me.pagingHelper.createSortOption("sort_nr", SortDirection.ASC));
  }

  // set subscriber for scrollbar and load data for next page when it is in the exact point.
  private setInifiniteScrollSunscriber() {
    const me = this;
    me.infiniteScrollSubscriber = me._scrollHelper.InfiniteScrollObserver().subscribe((loadNextPage) => {
      if (me.matGroupSelectedIndex === 1 && loadNextPage && !Utils.IsNull(me.paging)) {
        const itemList: HTMLElement[] = Array.from(me.locationListView.nativeElement.getElementsByClassName("location-item"));
        itemList.forEach(element => {
          element.style.removeProperty("position");
          element.style.removeProperty("top");
        });
        const nextpage = me.paging.nextPage();
        me.locationList.push(...nextpage);
        me.PushChanges();
        setTimeout(() => {
          me.setLocationsStyle();
        }, 200);
      }
    });
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("NewsComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /**set placeholder for search input */
  public setPlaceHolder() {
    const me = this;
    return me._coreLanguageService.value("phLocation_Search_Location");
  }

  /**
   * Get Like Location
   * @param likeList Like list of user
   */
  private async ReloadDataAndRender(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    const locationServiceStatus: LocationServiceStatus = await me._deviceLocationService.getLocationServiceStatus();
    me.locationService.GetLocationViewModel(true, false, locationServiceStatus)
      .then(location => {
        if (location) {
          me.hasData = true;
          const DefaultPageSize = !me.isSmallView ? 200 : 4;
          let CurrentPage = 2;
          if (!Utils.IsNull(me.paging)) {
            CurrentPage = me.paging.CurrentPage;
          }
          me.paging = new Paging(location, DefaultPageSize, me.sortOption, me.filterFunction);
          me.locationList = []; // clean up
          me.locationList.push(...me.paging.initLoad(CurrentPage));
          me.PushChanges();
        } else {
          me.hasData = false;
          me.PushChanges();
        }
        if (me.hasData) {
          setTimeout(() => {
            me.setLocationsStyle();
            if (locationServiceStatus === LocationServiceStatus.NotAuthorized || locationServiceStatus === LocationServiceStatus.BrowserMode) {
              me.setlocationDistance()
            }
          }, 200);
        }
        me._overlaySpinnerService.HideLayoutSpinner();
        me.animateItems();
      })
      .catch(e => {
        me._coreLogService.error("NewsComponent.ReloadDataAndRender", "GetLocationViewModel", e);
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(49);
      });
    // }
  }

  // set style for location list for animation effect
  private setLocationsStyle() {
    const me = this;
    const vh: number = +document.documentElement.style.getPropertyValue("--vh").replace("px", "");
    const itemList: HTMLElement[] = Array.from(me.locationListView.nativeElement.getElementsByClassName("location-item"));
    let topOffset = 0;
    const marginTop = 16;

    itemList.forEach(element => {
      element.style.position = "absolute";
      element.style.top = topOffset + "px";
      topOffset += element.offsetHeight + marginTop;
    });

    me.locationListView.nativeElement.style.height = topOffset + "px";
  }

  /**
   * set isSearchEnabled to show or hide SearchBox on top of the page.
   */
  public searchBoxActivation(): void {
    const me = this;
    me.isSearchEnabled = !me.isSearchEnabled;
    if (me.isSearchEnabled) {
      // for focus on MatInput we need to call focus function in a setTimeOut function
      setTimeout(_ => {
        me.searchInput.focus();
      });
    } else {
      if (me.searchLocationKey.length > 0) {
        me.searchLocationFilter("");
      }
    }
    me.PushChanges();
  }

  /**calculate location distance to current location base on lat and long
   * @param locations locationviewmodel list
  */
  private setlocationDistance(): void {
    const me = this;
    me._deviceLocationService.getCurrentPosition()
      .then((coordinates) => {
        if (coordinates) {
          me.locationList.forEach(loc => {
            if (loc.latitude > 0 && loc.longitude > 0) {
              loc.distance = +(Utils.getDistanceBetweenPoints(coordinates.latitude, coordinates.longitude, loc.latitude, loc.longitude).toFixed(1));
            } else {
              loc.distance = 1000000;// must be place at the end by sorting
            }
          });
          me.paging.setSorting(me.sortOption);
          me.locationList = []
          me.locationList = me.paging.initLoad();
          me.PushChanges();
          setTimeout(() => {
            me.setLocationsStyle();
          }, 200);
        }
      })
      .catch(error => {
        me._coreLogService.error("LocationComponent.setlocationDistance", "getCurrentPosition()", error);
      })
  }

  /**
   * This function filters LocationList when KeyUp Event of searchBox fired.
   * @param searchKey key for filtering Locationlist
   */
  public searchLocationFilter(searchKey: string): void {
    const me = this;
    me.filterFunction = [];
    me.searchLocationKey = searchKey;
    if (me.searchLocationKey.length > 1) {
      me.filterFunction.push(LocationComponent.locationLabelFilterFunction(me.searchLocationKey));
    }
    me.paging.setFilter(me.filterFunction);
    me.locationList = []; // clean up
    me.mapLocationList = []; // clean up
    me.locationList.push(...me.paging.initLoad());
    // if there is no filter, the list of map location must be filled with all data again.
    if (me.locationList.length === 0) {
      me.fitBounds = false;
      me.PushChanges();
    } else {
      me.fitBounds = true;
      if (me.searchLocationKey.length > 0) {
        me.mapLocationList.push(...me.locationList.filter(l => l.latitude > 0 && l.longitude > 0));
      } else {
        me.mapLocationList.push(...me.paging.getAllData().filter(l => l.latitude > 0 && l.longitude > 0));
      }
      me.PushChanges();
      setTimeout(() => {
        me.setLocationsStyle();
      }, 200);
    }
    me.PushChanges();
    me.animateItems();
  }
  /**get teb index from navigation bar and set tab page i navigation and tabs on page */
  public changeTab(index) {
    const me = this;
    me.matGroupSelectedIndex = index;
    me.activeLink = me.tabLocationStep[index];
    me.tabSelectedIndexChange(index);
  }

  public navigateBack(): void {
    this._routerHelperService.navigateBackSimple();
  }

  public navigateToLocationDetail(locationId: number | string): void {
    this._router.navigate(["/locationdetail", locationId]);
  }

  /**
   * Handle changeTabEvent
   * @param event event Instance
   */
  public tabSelectedIndexChange(index: number): void {
    const me = this;
    // me.locationTabIndex = index;
    // me.PushChanges();
    if (index === 1) {
      me.reloadLocationListTab();
    } else {
      me.reloadMapTab();
    }
  }

  private reloadLocationListTab() {
    const me = this;
    me.initializeMap = false;
    if (me.currentLocationMode) {
      me.currentLocationMode = false;
      me.mapLocationList = [];
      // me.mapLocationList.push(...me.locationList);
      if (me.searchLocationKey.length > 0) {
        me.mapLocationList.push(...me.locationList.filter(l => l.latitude > 0 && l.longitude > 0));
      } else {
        me.mapLocationList.push(...me.paging.getAllData().filter(l => l.latitude > 0 && l.longitude > 0));
      }
    }
    me.PushChanges();
    setTimeout(() => {
      me.setLocationsStyle();
    }, 200);
  }

  private reloadMapTab() {
    const me = this;
    if (!me.initializeMap && me.locationList.length > 0 && !me.currentLocationMode) {
      me.mapLocationList = [];
      if (me.searchLocationKey.length > 0) {
        me.mapLocationList.push(...me.locationList.filter(l => l.latitude > 0 && l.longitude > 0));
      } else {
        me.mapLocationList.push(...me.paging.getAllData().filter(l => l.latitude > 0 && l.longitude > 0));
      }
      me.initializeMap = true;
    }
    me.PushChanges();
  }

  // used for calculating location in googlemap
  private deg2Rad(deg): number {
    return deg * Math.PI / 180;
  }

  // used for calculating location in googlemap
  // Convert Degress to Radians
  private pythagorasEquirectangular(lat1, lon1, lat2, lon2): number {
    const me = this;
    lat1 = me.deg2Rad(lat1);
    lat2 = me.deg2Rad(lat2);
    lon1 = me.deg2Rad(lon1);
    lon2 = me.deg2Rad(lon2);
    const R = 6371; // km
    const x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
    const y = (lat2 - lat1);
    const d = Math.sqrt(x * x + y * y) * R;
    return d;
  }

  public swipeRightHandler() {
    const me = this;
    if (me.matGroupSelectedIndex === 1) {
      --me.matGroupSelectedIndex;
      me.activeLink = me.tabLocationStep[0];
      me.PushChanges();
    }
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
    if (me.infiniteScrollSubscriber) {
      me.infiniteScrollSubscriber.unsubscribe();
    }
    if (me.locationChangesSubscriber) {
      me.locationChangesSubscriber.unsubscribe();
    }
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
  }

  private animateItems() {
    const me = this;
    if (me.locationListView) {
      const Items = me.locationListView.nativeElement
        .getElementsByClassName("ya-content-item");
      setTimeout(() => {
        for (let i = 0; i < Items.length; i++) {
          const element = Items[i];
          setTimeout(() => {
            element.classList.add("item-animated");
          }, i * 100)
        }
      }, 100)
    }
  }
}
